<div class="line-loading">
  <ng-content></ng-content>
</div>
